jQuery(document).ready(function($) {
  /*----- utils -----*/
  const isMobile = () => {
    return $(window).width() <= 800;
  };


  /*----- header -----*/
  const $submenuArray = $(".menu-item .sub-menu");
  const $menuButton = $(".menu-toggle");

  if ($submenuArray) {
    $submenuArray.closest(".menu-item").addClass("dropdown");
  }

  function openDropdownMobile(event) {
    $(event.currentTarget).closest(".dropdown").toggleClass("open")
    $(this).siblings(".sub-menu").slideToggle(200);

    $(".sub-menu").not($(this).siblings()).slideUp();
    $(".dropdown").not($(this).closest(".dropdown")).removeClass("open");
    event.stopPropagation();

    $("html").click(function() {
      $(".sub-menu").slideUp();
      $(".dropdown").removeClass("open");
    });
  };

  function openDropdownDesktop(event) {
    event.preventDefault();
    $(event.currentTarget).addClass("open")
      .find(".sub-menu").addClass("shown");
  };

  function closeDropdownDesktop(event) {
    $(event.currentTarget)
      .closest(".dropdown").removeClass("open")
      .find(".sub-menu").removeClass("shown");
  };

  $(window).on("resize", function() {
    const $initMobile = $(".main-navigation").attr("init-mobile-menu");
    const $mainNavigation = $(".main-navigation");

    if (isMobile()) {
      if ($initMobile !== "true") {
        $mainNavigation.attr("init-mobile-menu", "true");

        $(".dropdown").off("mouseenter", openDropdownDesktop);
        $(".dropdown").off("mouseleave", closeDropdownDesktop);

        $(".dropdown > a").on("click", openDropdownMobile);
      }
    } else {
      if ($initMobile === "true") {
        $mainNavigation.attr("init-mobile-menu", "false");
      } else {
        $(" .dropdown > a").off("click", openDropdownMobile);

        $(".dropdown").on("mouseenter", openDropdownDesktop);
        $(".dropdown").on("mouseleave", closeDropdownDesktop);
      }
    }
  }).trigger("resize");

  $menuButton.on("click", function (event) {
    if ($(event.currentTarget).attr("aria-expanded") === "false") {
      $(event.currentTarget).attr("aria-expanded", "true");
      $("#menu-header-mobile").attr("aria-expanded", "true");

      $("body").addClass("noscroll");
    } else {
      $(event.currentTarget).attr("aria-expanded", "false");
      $("#menu-header-mobile").attr("aria-expanded", "false");

      $("body").removeClass("noscroll");
    }
  });


  /*----- lang select -----*/
  const $selectBlock = $(".select");
  const $selectContent = $(".select__trigger span");
  const $selectTrigger = $(".select__trigger");
  const $selectOptions = $(".select .option");

  function selectHandler() {
    $selectOptions.each(function (index, element) {
      if (isMobile()) {
        $(element).text($(element).data("mobile"));
      } else {
        $(element).text($(element).data("desktop"));
      }
    });

    if (isMobile()) {
      $selectTrigger.find(".lang__field--desktop").hide();
      $selectTrigger.find(".lang__field--mobile").show();
    } else {
      $selectTrigger.find(".lang__field--mobile").hide();
      $selectTrigger.find(".lang__field--desktop").show();
    }
  };
  selectHandler();

  $(window).on("resize", function() {
    selectHandler();
  });

  $selectBlock.on("click", function(event) {
    $(event.currentTarget).toggleClass("open");
  });

  $selectOptions.on("click", function(event) {
    if ($selectOptions.hasClass("selected")) {
      $selectOptions.removeClass("selected");
      $(event.currentTarget).addClass("selected");

      if (isMobile()) {
        const $selectText = $(event.currentTarget).data("mobile");
        $selectContent.text($selectText);
      } else {
        const $selectText = $(event.currentTarget).data("desktop");
        $selectContent.text($selectText);
      }
    }
  });
});






